// extracted by mini-css-extract-plugin
export default {"wrapper":"NoChatComponent_wrapper__Bsmoi"};